"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HardSciences = void 0;
var HardSciences;
(function (HardSciences) {
    HardSciences["ENGINEERING"] = "ENGINEERING";
    HardSciences["PHYSICS"] = "PHYSICS";
    HardSciences["CHEMISTRY"] = "CHEMISTRY";
    HardSciences["BIOLOGY"] = "BIOLOGY";
    HardSciences["COMPUTER_SCIENCE"] = "COMPUTER_SCIENCE";
    HardSciences["NOT_TECHNICAL"] = "NOT_TECHNICAL";
})(HardSciences || (exports.HardSciences = HardSciences = {}));
